const initialState = {
	loginId: null,
	loginPass: null,
	email: null,
	emailNotificationMail: 0,
	emailNotificationFavorite: 0,
	emailNotificationMember: 0,
	webpushCount: 0,
	webpushNotificationMail: 0,
	webpushNotificationFavorite: 0,
	twoFactorAuthentication: 0,
	chargeStart: 0,
	chargeEnd: 0,
	chargeAutomatic: 0,
	creditcardName: null,
	creditcardTel: null,
	creditcardEmail: null,
	introductionStop: 0,
	filterSearch: 0,
	filterMail: 0,
	nondisplayCount: 0,
	refusalCount: 0,
	timeline: 0,
	searchPublish: 0,
	serviceStop: 0,
	profileCheck: 0,
	profileWebmasterCheck: 0,
	chargeBan: 0,
	communityPostBan: 0,
	datetime: null,
};

export default function reducer(state = initialState, action) {

	if (action.type === 'MY_SETTING_SET') {
		let setting = action.payload;

		let newState = {
			loginId: setting.loginId,
			loginPass: setting.loginPass,
			email: setting.email,
			emailNotificationMail: setting.emailNotificationMail,
			emailNotificationFavorite: setting.emailNotificationFavorite,
			emailNotificationMember: setting.emailNotificationMember,
			webpushCount: setting.webpushCount,
			webpushNotificationMail: setting.webpushNotificationMail,
			webpushNotificationFavorite: setting.webpushNotificationFavorite,
			twoFactorAuthentication: setting.twoFactorAuthentication,
			chargeStart: setting.chargeStart,
			chargeEnd: setting.chargeEnd,
			chargeAutomatic: setting.chargeAutomatic,
			creditcardName: setting.creditcardName,
			creditcardTel: setting.creditcardTel,
			creditcardEmail: setting.creditcardEmail,
			introductionStop: setting.introductionStop,
			filterSearch: setting.filterSearch,
			filterMail: setting.filterMail,
			nondisplayCount: setting.nondisplayCount,
			refusalCount: setting.refusalCount,
			timeline: setting.timeline,
			searchPublish: setting.searchPublish,
			serviceStop: setting.serviceStop,
			profileCheck: setting.profileCheck,
			profileWebmasterCheck: setting.profileWebmasterCheck,
			chargeBan: setting.chargeBan,
			communityPostBan: setting.communityPostBan,
			datetime: (new Date()),
		}
		return newState;
	}
	else if (action.type === 'MY_SETTING_INIT') {
		return initialState;
	}
	else {
		return state;
	}
}
